import React from "react";
import { DownloadSimple } from "@phosphor-icons/react";
import { toast } from "sonner";
import CrudPage from "../../components/admin/CrudPage";
import { useAdminAuth, formatApiErrorDetail } from "../../lib/admin-auth-context";

const STATUS_OPTIONS = [
  { value: "issued", label: "Emitida" },
  { value: "paid", label: "Pagada" },
  { value: "overdue", label: "Vencida" },
  { value: "cancelled", label: "Cancelada" },
];
const STATUS_MAP = {
  issued: { label: "Emitida", color: "blue" },
  paid: { label: "Pagada", color: "green" },
  overdue: { label: "Vencida", color: "red" },
  cancelled: { label: "Cancelada", color: "slate" },
};

const PdfButton = ({ invoice }) => {
  const { api } = useAdminAuth();
  const download = async (e) => {
    e.stopPropagation();
    try {
      const res = await api.get(`/invoices/${invoice.id}/pdf`, {
        responseType: "blob",
      });
      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `ICOR-${invoice.folio || invoice.id}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(
        formatApiErrorDetail(err.response?.data?.detail) || err.message
      );
    }
  };
  return (
    <button
      onClick={download}
      data-testid={`admin-invoice-pdf-${invoice.id}`}
      className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-[var(--icor-blue)] hover:underline"
      title="Descargar PDF"
    >
      <DownloadSimple size={14} weight="bold" /> PDF
    </button>
  );
};

const config = {
  title: "Facturas",
  eyebrow: "Finanzas",
  resource: "invoices",
  columns: [
    { key: "folio", label: "Folio" },
    { key: "client_name", label: "Cliente" },
    { key: "amount", label: "Importe", type: "currency" },
    { key: "status", label: "Estado", type: "status", statusMap: STATUS_MAP },
    { key: "issued_at", label: "Emitida", type: "date" },
    { key: "due_at", label: "Vence", type: "date" },
    { key: "pdf", label: "PDF", render: (r) => <PdfButton invoice={r} /> },
  ],
  fields: [
    { key: "folio", label: "Folio fiscal", required: true },
    { key: "client_name", label: "Cliente", required: true },
    { key: "amount", label: "Importe MXN", type: "number", required: true },
    { key: "status", label: "Estado", type: "select", options: STATUS_OPTIONS, required: true },
  ],
};

export default function AdminInvoices() {
  return <CrudPage config={config} />;
}
